export default __webpack_public_path__ + "static/media/sc20.e7b94560.jpg";